import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import Selector from 'components/DesignSystem/Selector';

type ModelOnChange =
  | ((value: string) => void)
  | ((event: React.ChangeEvent<HTMLInputElement>) => void);

interface ModelProps {
  value?: string;
  onChange: ModelOnChange;
  models: string[];
}

export default function Model({ value, onChange, models }: ModelProps) {
  const useSelectorWithSearch = value !== undefined;

  return (
    <Accordion.Item eventKey="model">
      <Accordion.Header>Modelo</Accordion.Header>
      <Accordion.Body>
        {useSelectorWithSearch ? (
          <Selector
            value={value}
            setValue={(v) => (onChange as (value: string) => void)(v !== undefined && v !== null ? String(v) : '')}
            search
            searchPlaceholder="Buscar modelo..."
            placeholder="Selecione um modelo"
            containerClassName="w-100"
            itemContainerMaxHeight="160px"
          >
            {models.map((model) => (
              <option key={model} value={model}>
                {model}
              </option>
            ))}
          </Selector>
        ) : (
          <Container>
            {models.map((model) => (
              <Row key={model}>
                <Col key={model}>
                  <RadioButton
                    name="model"
                    label={model}
                    onChange={onChange as (event: React.ChangeEvent<HTMLInputElement>) => void}
                    value={model}
                  />
                </Col>
              </Row>
            ))}
          </Container>
        )}
      </Accordion.Body>
    </Accordion.Item>
  );
}
